export class StringUtils {
  static isBlank(s: string | undefined | null): boolean {
    if (s === undefined) {
      return true;
    }
    if (s === null) {
      return true;
    }
    const trimmed = s.trim();
    return trimmed.length === 0;
  }

  static isNotBlank(str: string | undefined | null): str is string {
    return !StringUtils.isBlank(str);
  }

  static trimToUndefined(s: string | undefined | null): string | undefined {
    if (s === undefined) {
      return undefined;
    }
    if (s === null) {
      return undefined;
    }
    const trimmed = s.trim();
    if (trimmed.length === 0) {
      return undefined;
    }
    return trimmed;
  }

  static trimToEmpty(s: string | undefined | null): string {
    if (s === undefined) {
      return '';
    }
    if (s === null) {
      return '';
    }
    const trimmed = s.trim();
    if (trimmed.length === 0) {
      return '';
    }
    return trimmed;
  }

  static capitalize(s: string | undefined | null): string {
    const trimmed = this.trimToEmpty(s);
    if (trimmed.length === 0) {
      return '';
    }
    return trimmed
      .split(/[ _]+/)
      .map((value: string) => value.charAt(0).toUpperCase() + value.slice(1).toLowerCase())
      .join(' ');
  }

  static stringify(obj: any): string {
    let cache: any = [];
    const jsonString = JSON.stringify(obj, function (key, value) {
      if (typeof value === 'object' && value !== null) {
        if (cache.indexOf(value) !== -1) {
          // Duplicate reference found
          try {
            // If this value does not reference a parent it can be deduped
            return JSON.parse(JSON.stringify(value));
          } catch (error) {
            // discard key if value cannot be deduped
            return;
          }
        }
        // Store value in our collection
        cache.push(value);
      }
      return value;
    });
    cache = null;
    return jsonString;
  }
}
